import { render } from "./AdmListaUserView.vue?vue&type=template&id=0b796154"
import script from "./AdmListaUserView.vue?vue&type=script&lang=js"
export * from "./AdmListaUserView.vue?vue&type=script&lang=js"

import exportComponent from "G:\\Projeto_ELITE\\VUE\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__